export const REGEX_PHONE = {
  SG_WITH_DIALCODE: /^\+65(6|8|9)\d{7}$/,
  SG_PHONE_WITHOUT_DIALCODE: /^(6|8|9)\d{7}$/,
};
